import React from 'react';
import { twMerge } from 'tailwind-merge';
type ContainerProps = {
  children: React.ReactNode;
  className?: string;
};
export function Container({
  children,
  className
}: ContainerProps) {
  return <div className={twMerge('mx-auto w-full max-w-[1160px] px-5 sm:px-8', className)} data-id="element-91" data-mp="3bj48un4t6gf4">{children}</div>;
}